export default __webpack_public_path__ + "static/mark-ae4514dcdf07d5ffba82226e6d4286aa.png";